var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "editarTime", attrs: { row: "", "justify-center": "" } },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Editar Time"
                                                : "Ver Detalle Time Howen"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: { sm6: "", md4: "", "d-flex": "" }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.dateformat.label,
                                          items:
                                            _vm.formFields.dateformat.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedDateFormat,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.dateformat.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.dateformat,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.dateformat.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: { sm6: "", md4: "", "d-flex": "" }
                                    },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          label: _vm.formFields.fecha.label,
                                          rules: [_vm.rules.required],
                                          value: _vm.selectedDate,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.fecha.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.fecha,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.fecha.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", md4: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.timesync.label,
                                          items: _vm.formFields.timesync.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedSwitch,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.timesync.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.timesync,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.timesync.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm4: "", md4: "" } },
                                    [
                                      _c("TimePicker", {
                                        attrs: {
                                          label: _vm.formFields.time.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.time.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.time,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.time.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.timeout.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.timeout.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.timeout,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.timeout.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.timeZone.label,
                                          items: _vm.formFields.timeZone.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedTimeZone,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.timeZone.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.timeZone,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.timeZone.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.ntp.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.ntp.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.ntp,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.ntp.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm2: "", md2: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.ntp2.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.ntp2.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.ntp2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.ntp2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.dts.label,
                                          items: _vm.formFields.dts.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedDts,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.dts.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.dts,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.dts.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm4: "", md4: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.startTimeMonth.label,
                                          items:
                                            _vm.formFields.startTimeMonth.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedStartMonth,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.startTimeMonth.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.startTimeMonth,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.startTimeMonth.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm2: "", md2: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.starttime.label,
                                          items: _vm.formFields.starttime.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedStartTime,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.starttime.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.starttime,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.starttime.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm1: "", md1: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.startdayofweek.label,
                                          items:
                                            _vm.formFields.startdayofweek.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedStartDay,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.startdayofweek.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.startdayofweek,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.startdayofweek.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm1: "", md1: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.startday.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.startday.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.startday,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.startday.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm4: "", md4: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.endtimemonth.label,
                                          items:
                                            _vm.formFields.endtimemonth.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedEndMonth,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.endtimemonth.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.endtimemonth,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.endtimemonth.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm2: "", md2: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.endtime.label,
                                          items: _vm.formFields.endtime.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedEndTime,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.endtime.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.endtime,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.endtime.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm1: "", md1: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.enddayofweek.label,
                                          items:
                                            _vm.formFields.enddayofweek.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedEndDayWeek,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.enddayofweek.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.enddayofweek,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.enddayofweek.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { sm1: "", md1: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.endday.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.endday.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.endday,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.endday.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.offsettime.label,
                                          items:
                                            _vm.formFields.offsettime.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedOffTime,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.offsettime.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.offsettime,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.offsettime.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }